import { makeRequest, REQUEST_TYPE } from "./request";
import { KOR_API_PRIVATE } from "../entry";

KOR_API_PRIVATE.mail = async (props) =>
  makeRequest(props, "mail", REQUEST_TYPE.POST_MAIL);
